import { useTimelineCtx } from "../ctx";

export const useTimelineIsItemOutside = (itemIdx: number): boolean => {
  const { itemsMovedBy, itemsInView } = useTimelineCtx();
  return itemIdx < itemsMovedBy || itemIdx - itemsMovedBy >= itemsInView;
};
